import React from "react";
import { gql, useMutation, useQuery } from "@apollo/client";
import { Form } from "react-final-form";
import { Remarkable } from "remarkable";
import { SwitchField, DateTimeField } from "@syos-music/form";

import { styled, Grid } from "@mui/material";

import Layout from "components/common/Layout";
import SaveFab from "components/common/SaveFab";
import MarkdownField from "components/form/MarkdownField";

const md = new Remarkable({ html: false });

const QUERY = gql`
  query {
    webBanner {
      id
      published
      content {
        en
        fr
      }
      expires
    }
  }
`;

const MUTATION = gql`
  mutation ($published: Boolean, $content: IntlStringInput, $expires: Date) {
    UpdateWebBanner(
      published: $published
      content: $content
      expires: $expires
    ) {
      webBanner {
        id
        published
        content {
          en
          fr
        }
        expires
      }
    }
  }
`;

const Preview = styled("div")(({ theme }) => ({
  marginTop: theme.spacing(2),
  padding: theme.spacing(1, 2),
  backgroundColor: theme.palette.error.light,
  color: theme.palette.error.contrastText,

  "& p": { margin: "0 0 0.3em" },
  "& p:last-child": { marginBottom: 0 },
  "& a": { color: "currentColor" },
}));

export default function BannerEditor() {
  const [updateWebBanner] = useMutation(MUTATION);

  const { data, loading } = useQuery(QUERY);

  if (loading) return <Layout.Loading />;
  if (!data?.webBanner) return <Layout.NotFound />;

  return (
    <Form
      onSubmit={async (values) =>
        updateWebBanner({ variables: values })
          .then(() => {})
          .catch(() => true)
      }
      initialValues={data.webBanner}
    >
      {({ handleSubmit, pristine, submitting, values }) => (
        <form onSubmit={handleSubmit} noValidate autoComplete="off">
          <Grid container alignItems="center">
            <Grid item>
              <SwitchField name="published" label="Publié" />
            </Grid>

            <Grid item xs>
              <DateTimeField
                name="expires"
                label="Date d’expiration"
                fullWidth
                parse={(value) => value ?? null}
              />
            </Grid>

            <Grid item>
              <SaveFab
                onSave={handleSubmit}
                disabled={pristine}
                loading={submitting}
              />
            </Grid>

            <Grid item xs={12}></Grid>

            <Grid item xs={12} md={6} sx={{ alignSelf: "flex-start" }}>
              <MarkdownField name="content.fr" required label="🇫🇷 Contenu" />
            </Grid>

            <Grid item xs={12} md={6} sx={{ alignSelf: "flex-start" }}>
              <MarkdownField name="content.en" required label="🇬🇧 Contenu" />
            </Grid>

            <Grid item xs={12} md={6} sx={{ alignSelf: "flex-start" }}>
              <Preview
                dangerouslySetInnerHTML={{
                  __html: md.render(values.content.fr),
                }}
              />
            </Grid>

            <Grid item xs={12} md={6} sx={{ alignSelf: "flex-start" }}>
              <Preview
                dangerouslySetInnerHTML={{
                  __html: md.render(values.content.en),
                }}
              />
            </Grid>
          </Grid>
        </form>
      )}
    </Form>
  );
}
